module.exports = __webpack_public_path__ + "static/media/sports.1aaac743.png";